import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute, Params } from "@angular/router";
import {
  AbstractControl,
  FormArray,
  FormBuilder,
  Validators,
  FormGroup,
} from "@angular/forms";

import { ConfirmationService } from "primeng/primeng";

import { InscricaoService } from "./../../../services/inscricao.service";

import { Categoria } from "./../../../models/categoria";
import { Comoconheceu } from "./../../../models/comoconheceu";
import { Deficiencia } from "./../../../models/deficiencia";
import { Escolaridade } from "./../../../models/escolaridade";
import { Estadocivil } from "./../../../models/estadocivil";
import { Racacor } from "./../../../models/racacor";
import { Uf } from "./../../../models/uf";
import { Unidade } from "./../../../models/unidade";
import { Endereco } from "./../../../models/endereco";
import { Classificacao } from "./../../../models/classificacao";

import { CustomValidator } from "../../shared/validators/custom.validator";
import { Observable } from "rxjs/Observable";
import { Util } from "../../shared/util";
import { MessageService } from "primeng/components/common/messageservice";
import { WebPage } from "../../shared/web-page";
import { UnidadeService } from "../../shared/services/unidade.service";
import { ArquivoService } from "../../shared/services/arquivo.service";
import { LgpdService } from "../../../services/lgpd.service";
import { FaseService } from "../../fase/fase.service";

@Component({
  templateUrl: "./inscricao-form.component.html",
})
export class InscricaoFormComponent extends WebPage implements OnInit {
  exibirModalAceiteLGPD: boolean = false;
  confirmouAceiteLGPD: boolean = false;
  listaCategoria: Categoria[];
  listaComoconheceu: Comoconheceu[];
  listaDeficiencia: Deficiencia[];
  listaClassificacao: Classificacao[];
  listaEscolaridade: Escolaridade[];
  listaEstadocivil: Estadocivil[];
  listaRacacor: Racacor[];
  listaUf: Uf[];
  desabilitarNumero = false;

  categoriasCadastradas = [];

  unidade = new Unidade();
  endereco = new Endereco();

  camposCepDisabled = false;
  complementoDisabled = false;

  isSubmitted = false;
  storedItems;
  uploadUrl: string;
  arquivosToRemove = new FormArray([]);

  get ConfirmeEmail() {
    return this.form.get("ConfirmeEmail");
  }
  get Cep() {
    return this.form.get("Cep");
  }
  get DataCnh() {
    return this.form.get("DataCnh");
  }
  get arquivos() {
    return this.form.get("Arquivos") as FormArray;
  }

  public form: FormGroup;
  constructor(
    private fb: FormBuilder,
    private router: Router,
    private confirmationService: ConfirmationService,
    messageService: MessageService,
    private inscricaoService: InscricaoService,
    private unidadeService: UnidadeService,
    private arquivoService: ArquivoService,
    private lgpdService: LgpdService,
    private faseService: FaseService
  ) {
    super(messageService);

    this.storedItems = JSON.parse(localStorage.getItem("dadosPrincipais"));
    //console.log(this.storedItems);

    this.form = fb.group({
      idFase: [this.storedItems.idFase],
      Cpf: [this.storedItems.cpf],
      Nome: ["", [Validators.maxLength(200), Validators.required]],
      Datanascimento: [this.storedItems.dataNascimento],
      Sexo: ["", Validators.required],
      Nomepai: ["", [Validators.maxLength(200), Validators.required]],
      Nomemae: ["", [Validators.maxLength(200), Validators.required]],
      IdUnidade: [""],
      Unidade: [""],
      Rg: ["", [Validators.maxLength(50), Validators.required]],
      Orgao: ["", [Validators.maxLength(100), Validators.required]],
      IdUfOrgao: ["", Validators.required],
      Nacionalidade: ["", [Validators.maxLength(200), Validators.required]],
      Naturalidade: ["", [Validators.maxLength(200), Validators.required]],
      IdRacaCor: ["", Validators.required],
      IdEstadoCivil: ["", Validators.required],
      IdEscolaridade: ["", Validators.required],
      RendaIndividual: [this.storedItems.salario],
      SituacaoEmpregaticia: [this.storedItems.cnpj ? "Empregado" : ""],
      IdComoConheceu: ["", Validators.required],
      IdClassificacao: ["dddc624c-ebe7-4859-b8ad-0cfad3fe10d2", Validators.required],
      Observacao: ["", Validators.maxLength(500)],
      Cnpj: [this.storedItems.cnpj],
      RazaoSocial: [this.storedItems.razaoSocial],
      Ocupacao: [this.storedItems.cnpj ? "Empregado" : ""],
      TelefonePreferencial: ["", Validators.required],
      TelefoneOpcional1: [""],
      TelefoneOpcional2: [""],
      Email: [
        "",
        [
          Validators.minLength(5),
          Validators.maxLength(200),
          Validators.required,
          CustomValidator.EmailValidator,
        ],
      ],
      ConfirmeEmail: [
        "",
        [
          Validators.minLength(5),
          Validators.maxLength(200),
          Validators.required,
          CustomValidator.EmailValidator,
        ],
      ],
      Cep: ["", [Validators.minLength(10), Validators.required]],
      Logradouro: ["", [Validators.maxLength(200), Validators.required]],
      Numero: ["", [Validators.maxLength(50), Validators.required]],
      Complemento: [""],
      Bairro: ["", [Validators.maxLength(200), Validators.required]],
      Cidade: ["", Validators.required],
      Uf: ["", Validators.required],
      NumeroCnh: ["", [Validators.maxLength(50), Validators.required]],
      DataCnh: ["", Validators.required],
      ValidadeCNH: ["", Validators.required],
      IdCategoriaAtual: ["", Validators.required],
      IdCategoriaPretendida: ["", Validators.required],
      IdDeficiencia: ["", Validators.required],
      Arquivos: new FormArray([]),
    });

    this.uploadUrl =
      this.arquivoService.uploadUrl + "termoCompartilhamentoDesempenho";
  }

  ngOnInit() {
    this.isLoading = true;
    this.getCategoriasSelecionadas();
    Observable.combineLatest(
      this.unidadeService.getListaUf(),
      this.inscricaoService.getListaRacacor(),
      this.inscricaoService.getListaEstadocivil(),
      this.inscricaoService.getListaEscolaridade(),
      this.inscricaoService.getListaComoconheceu(),
      this.inscricaoService.getListaClassificacao(),
      this.inscricaoService.getListaCategoria(),
      this.inscricaoService.getListaDeficiencia(),
      this.unidadeService.getUnidade(this.storedItems.idUnidade)
    )
      .finally(() => (this.isLoading = false))
      .subscribe(
        (combined) => {
          this.listaUf = combined[0] as Uf[];
          this.listaRacacor = combined[1] as Racacor[];
          this.listaEstadocivil = combined[2] as Estadocivil[];
          this.listaEscolaridade = combined[3] as Escolaridade[];
          this.listaComoconheceu = combined[4] as Comoconheceu[];
          this.listaClassificacao = combined[5] as Classificacao[];
          this.listaCategoria = combined[6] as Categoria[];
          this.listaDeficiencia = combined[7] as Deficiencia[];
          this.unidade = new Unidade(combined[8]);
          this.form.patchValue({
            IdUnidade: this.unidade.idUnidade,
            Unidade: this.unidade.nomeUnidade,
          });
        },
        (error) => this.gerenciaErro(error)
      );
    this.form.controls['IdCategoriaAtual'].valueChanges.subscribe(
      () => {
        this.atualizarCategoriaPretendida();
      }
    );
  }

  getCategoriasSelecionadas(){
    this.faseService.getFull(this.storedItems.idFase).subscribe((v) => {
      if(v !== null) {
        if(v.tipoEdital !== null && v.tipoEdital !== undefined && v.tipoEdital.nome === "Pessoa Jurídica"){
          this.inscricaoService.getCategoriaByEmpresaFaseUnidade(this.storedItems.cnpj, this.storedItems.idFase, this.storedItems.idUnidade).subscribe((categorias)=>{
            this.categoriasCadastradas = categorias.map((c) => c.idCategoria);
          })
        } else{
          v.faseUnidades.forEach(faseUnidade => {
            const categorias = faseUnidade.faseUnidadeCategoria.map((v) => v.idCategoria);
            if(faseUnidade.idUnidade === this.storedItems.idUnidade){
              this.categoriasCadastradas = categorias;
            }
          });
        }

      }
    })
  }
  atualizarCategoriaPretendida(){
    const categoriaIds = this.getCategoriasPretendidas().map(v => v.idCategoria)
    if (!categoriaIds.includes(this.form.controls.IdCategoriaPretendida.value)){
      this.form.controls.IdCategoriaPretendida.setValue('');
    }
  }

  getCategoriasPretendidas(){
    let categoriasPossiveis = [];
    let categoriaAtual = this.form.controls.IdCategoriaAtual.value;

    if(categoriaAtual === '3db0cf4c-8156-4fbc-b0a0-5fdade55027c'){ //C
      categoriasPossiveis = ['3dc4fd04-a088-486a-8f45-f85b6d7f96b3', '6c388665-75f3-44d0-ad2c-301f76e51b0b']; //D, E
    } else if(categoriaAtual === '4b3b98b5-6dda-492e-afbd-fbaab06e01e2'){ //B
      categoriasPossiveis = ['3dc4fd04-a088-486a-8f45-f85b6d7f96b3', '3db0cf4c-8156-4fbc-b0a0-5fdade55027c']; //D, C
    } else if (categoriaAtual === '3dc4fd04-a088-486a-8f45-f85b6d7f96b3'){ //D
      categoriasPossiveis = ['6c388665-75f3-44d0-ad2c-301f76e51b0b']; //E
    }

    if(this.listaCategoria !== undefined) {
      return this.listaCategoria.filter(v => {
        return categoriasPossiveis.includes(v.idCategoria)
      });
    } else{
      return [];
    }
  }

  numeroObrigatorio(naoEhObrigatorio: boolean) {
    if(naoEhObrigatorio){
      this.form.get('Numero').clearValidators();
      this.form.get('Numero').setValue("");
      this.form.get('Numero').setValidators(Validators.maxLength(50));
      this.desabilitarNumero = true;
    } else {
      this.form.get('Numero').setValidators(Validators.required);
      this.form.get('Numero').setValue("");
      this.desabilitarNumero = false;
    }
    this.form.get('Numero').updateValueAndValidity();
  }

  allowOnlyLetters(letter: string){
    return /[a-zàèìòùÀÈÌÒÙáéíóúýÁÉÍÓÚÝâêîôûÂÊÎÔÛãñõÃÑÕäëïöüÿÄËÏÖÜŸçÇ ]/i.test(letter);
  }

  allowOnlyNumbers(number: string){
    return number == "Backspace" || number == "Delete" || number == "ArrowLeft" || number == "ArrowRight" || /[0-9]/i.test(number);
  }

  setUpperCase(formControlName: string, value: string, formGroupName: string = null) {
    const nomeControles = formGroupName !== null ? formGroupName + '.' +  formControlName : formControlName;
    this.form.get(nomeControles).setValue(value.toUpperCase());
  }

  private validaEmail() {
    if (this.form.get("Email").value !== this.ConfirmeEmail.value) {
      this.messageService.add({
        severity: "warn",
        summary: "Atenção",
        detail: "E-mail incorreto.",
      });
      this.ConfirmeEmail.setValue("");
    }
  }

  getEnderecoByCep() {
    this.endereco.cidade = "";
    this.endereco.logradouro = "";
    this.endereco.bairro = "";
    this.endereco.uf = "";

    this.isLoading = true;
    this.inscricaoService
      .getEnderecoByCepSest(Util.limpaCep(this.Cep.value))
      .finally(() => (this.isLoading = false))
      .subscribe(
        (data) => {
          // if (data === 'invalido') {
          //   this.messageService.add({
          //     severity: 'warn',
          //     summary: 'Atenção',
          //     detail: 'O CEP deve ser da mesma UF da Unidade Operacional!'
          //   });
          //   this.Cep.setValue('');
          // } else {
          this.endereco = new Endereco(data);
          this.form.patchValue({
            Cidade: this.endereco.cidade,
            Logradouro: this.endereco.logradouro,
            Bairro: this.endereco.bairro,
            Uf: this.endereco.uf,
            Complemento: this.endereco.complemento
          });
          this.camposCepDisabled = this.endereco.bairro !== "" && this.endereco.logradouro !== "" && this.endereco.cidade !== "";
          this.complementoDisabled = this.endereco.complemento !== "";
          // }
        },
        (error) => {
          this.camposCepDisabled = false;
          this.complementoDisabled = false;
          this.form.patchValue({
            Cidade: '',
            Logradouro: '',
            Bairro: '',
            Uf: '',
            Complemento: ''
          });
          this.gerenciaErro(error);
        }
      );
  }


  validaCnh() {
    const dataEmissao = this.DataCnh.value;
    const categoriaAtual = this.getCategoriaAtualTexto();
    const categoriaPretendida = this.getCategoriaPretendidaTexto();

    // Se não há categoria pretendida selecionada, não faz validação
    if (!categoriaPretendida || categoriaAtual === categoriaPretendida) {
      return;
    }
    console.log('data Emissao', dataEmissao)
    console.log('categoria Atual', categoriaAtual)
    console.log('categoria Pretendida', categoriaPretendida)
    // Valida usando o utilitário local
    const isValido = Util.validaCnhProgressaoCategoria(dataEmissao, categoriaAtual, categoriaPretendida);

    if (!isValido) {
      this.messageService.add({
        severity: "warn",
        summary: "Atenção",
        detail: "O candidato não possui o tempo mínimo de habilitação exigida pelo Contran para a categoria pretendida.",
      });
      // Limpa a categoria pretendida em vez da data
      this.form.get('IdCategoriaPretendida').setValue('');
    }
  }

  private getCategoriaAtualTexto(): string {
    const formControl = this.form.get('IdCategoriaAtual');
    const idCategoriaAtual = formControl ? formControl.value : null;
    const categoriaMap = {
      '4b3b98b5-6dda-492e-afbd-fbaab06e01e2': 'B',
      '3db0cf4c-8156-4fbc-b0a0-5fdade55027c': 'C',
      '3dc4fd04-a088-486a-8f45-f85b6d7f96b3': 'D'
    };
    return categoriaMap[idCategoriaAtual] || '';
  }

  private getCategoriaPretendidaTexto(): string {
    const formControl = this.form.get('IdCategoriaPretendida');
    const idCategoriaPretendida = formControl ? formControl.value : null;
    const categoriaMap = {
      '3db0cf4c-8156-4fbc-b0a0-5fdade55027c': 'C',
      '3dc4fd04-a088-486a-8f45-f85b6d7f96b3': 'D',
      '6c388665-75f3-44d0-ad2c-301f76e51b0b': 'E'
    };
    return categoriaMap[idCategoriaPretendida] || '';
  }

  submit() {
    this.isSubmitted = true;
    if (this.form.invalid) {
      this.messageService.add({
        severity: "warn",
        summary: "Atenção",
        detail: "Campo obrigatório não preenchido!",
      });
      return;
    }

    // if (this.arquivos.value.length === 0) {
    //   this.messageService.add({
    //     severity: "warn",
    //     summary: "Atenção",
    //     detail:
    //       "Campo <b>Termo de Compartilhamento de Desempenho</b> obrigatório não preenchido!",
    //   });
    //   return;
    // }
    if (!this.confirmouAceiteLGPD) {
      this.exibirModalAceiteLGPD = true;
      return;
    }
    this.confirmationService.confirm({
      message: "Deseja enviar os dados digitados?",
      header: "Confirmação",
      icon: "fa fa-question-circle",
      accept: () => {
        this.isLoading = true;
        const idSistema = "75A923BF-02FF-4E82-A87A-775D32351A65";
        this.lgpdService
          .aceitarTermoUsuario({
            idTipoAcao: "444B0C2C-8AA1-444F-8FA5-4600982FCAF8",
            idTipoTermo: "F71EB9B2-5E77-48D3-804A-0F4B6E6F78CB",
            idSistema,
            cpf: this.form.get("Cpf").value.replace('.', '').replace('.','').replace('-', ''),
          })
          .subscribe(
            () => {
              this.lgpdService
                .aceitarTermoUsuario({
                  idTipoAcao: "8995D223-9859-43EF-B34E-ACB62F832A23",
                  idTipoTermo: "9EAB7BC0-CA18-4151-B0EA-9093DD3FF983",
                  idSistema,
                  cpf: this.form.get("Cpf").value.replace('.', '').replace('.','').replace('-', ''),
                })
                .subscribe(
                  () => {
                    this.inscricaoService
                      .inserirCandidato(this.form.value)
                      .finally(() => (this.isLoading = false))
                      .subscribe(
                        (result) => {
                          // localStorage.setItem(
                          //   "mensagem",
                          //   "Inscrição realizada com sucesso! A comprovação da inscrição será encaminhada para o e-mail cadastrado."
                          // );

                          this.messageService.add({
                            severity: 'success',
                            summary: 'Confirmação',
                            detail: 'Inscrição realizada com sucesso! A comprovação da inscrição será encaminhada para o e-mail cadastrado.'
                          });

                          this.exibirModalAceiteLGPD = false;
                          localStorage.removeItem("dadosPrincipais");
                          this.router.navigate([
                            "/termo-aceite/" + this.form.value.idFase,
                          ]);

                        },(error) => {
                          this.messageService.add({
                            severity: "error",
                            summary: "Alerta!",
                            detail: "Inscrição não realizada! Favor acionar o administrador do sistema."
                          })
                      }
                      );
                  },
                  (error) =>
                    this.gerenciaErro(
                      "Ocorreu um erro ao aceitar o termo de uso de imagem e voz."
                    )
                );
            },
            (error) =>
              this.gerenciaErro(
                "Ocorreu um erro ao aceitar o termo de privacidade."
              )
          );

      },
      reject: () => {
        this.messageService.add({
          severity: "warn",
          summary: "Atenção",
          detail: "Dados não enviados!",
        });
      },
    });
  }

  adicionaArquivo(idArquivo, nomeArquivo, isOld: boolean) {
    this.isLoading = false;

    const arquivoFormGroup = this.fb.group({
      idArquivo: idArquivo,
      nomeArquivo: nomeArquivo,
      isOld: isOld,
    });
    this.arquivos.push(arquivoFormGroup);
  }

  removeArquivo(arquivo: AbstractControl) {
    this.arquivosToRemove.push(arquivo);

    const index = this.arquivos.controls.indexOf(arquivo);
    this.arquivos.removeAt(index);
  }

  uploadError(mensagem) {
    this.messageService.add({
      severity: "warn",
      summary: "Atenção",
      detail: mensagem,
    });
    this.isLoading = false;
  }
  onFecharModal(evento: any) {
    this.exibirModalAceiteLGPD = false;
    if (evento.confirmado) {
      this.confirmouAceiteLGPD = true;
      this.submit();
    } else {
      this.confirmouAceiteLGPD = false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/candidato/inscricao-form/inscricao-form.component.ts